'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _FileMetadataRecord = require('../../file-metadata/records/FileMetadataRecord');

var _FileMetadataRecord2 = _interopRequireDefault(_FileMetadataRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResolvedAttachmentRecord = function (_Record) {
  _inherits(ResolvedAttachmentRecord, _Record);

  function ResolvedAttachmentRecord() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ResolvedAttachmentRecord);

    return _possibleConstructorReturn(this, (ResolvedAttachmentRecord.__proto__ || Object.getPrototypeOf(ResolvedAttachmentRecord)).call(this, _extends({}, properties, {
      fileMetadata: properties.fileMetadata ? new _FileMetadataRecord2.default(properties.fileMetadata) : null,
      thumbnailMetadata: properties.thumbnailMetadata ? new _FileMetadataRecord2.default(properties.thumbnailMetadata) : null
    })));
  }

  return ResolvedAttachmentRecord;
}((0, _immutable.Record)({
  fileId: null,
  fileMetadata: null,
  thumbnailMetadata: null
}));

exports.default = ResolvedAttachmentRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/resolved-attachment/records/ResolvedAttachmentRecord.js
// module id = 425
// module chunks = 2 3